import '../../../../../../../Avency.Nwd.Shop/Resources/Private/Assets/JavaScripts/Project/globals';

/**
 * Initialize ArticleHeader
 *
 * Polyfill for Browsers that are not supporting the `:has` css selector
 */
(function(PageLoadedQueue) {
    const supportsSelector = CSS.supports('selector(:has(body))');

    if (!supportsSelector) {
        const articleHeaderPolyfill = () => {

            const articleHeaderRight = document.querySelector('.article-header-right');

            if (articleHeaderRight) {
                const hasDiscountList = articleHeaderRight.querySelector('.article-header-right-price .nwd-price-wrapper > .article-quantity-discount-list');
                const hasVariantButton = articleHeaderRight.querySelector('.article-header-right-actions .article-variants-action-wrapper:not(.invisible)');

                if (!hasDiscountList || !hasVariantButton) {
                    const quantityDiscounts = articleHeaderRight.querySelector('.article-quantity-discount-variants')
                    quantityDiscounts.classList.add('d-none');
                }
            }
        }

        document.addEventListener('Plandent.Buy.DataLoadedAll', articleHeaderPolyfill, {passive: true});
        window.PageLoadedQueue.addFunction(function () {
            articleHeaderPolyfill();
        });
    }
})(window.PageLoadedQueue);
